import { UIDisplayAdapter } from '../../components/display_UI_adapter';

export const CVPage = () => {
    return <UIDisplayAdapter />;
};
